import GlobalTable from "@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue";
import {
  ASSIGN_MAIN_QUESTION_AS_DEPENDENT,
  GET_ASSIGNED_DATA_POINTS,
  GET_FORM_WITH_MAIN_SECTIONS,
  get_headers,
  get_project_id,
  GET_QUESTIONS_IN_PROJECT,
  GET_SECTIONS_IN_FORM,
  get_token,
  LIST_DATA_POINTS_URL,
  QUESTION_TYPE_URLS,
  REORDER_SECTION_QUESTIONS,
  SECTIONS_LIST_URLS,
  UNASSIGN_DEPENDENT_QUESTION,
  UNASSIGN_QUESTIONS_TO_FORM_SECTION,
} from "@/utils/constants/constants";
import alert_mixin from "@/utils/mixins/alert_mixin";
import create_questions_crud_mixins from "@/utils/mixins/create_questions_crud_mixins";
import dependent_questions_mixin from "@/utils/mixins/dependent_questions_mixin";
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import CreateQuestions from "@/views/probaworkflows_base/management/survey_managment/create_questions/CreateQuestions.vue";
import CreateSections from "@/views/probaworkflows_base/management/survey_managment/create_sections/CreateSections.vue";
import PreviewForm from "@/views/probaworkflows_base/management/survey_managment/preview_form/PreviewForm.vue";
import axios from "axios";
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css";
import $ from "jquery";
import { nextTick } from "vue";

const SELECT_TYPES = ["multi_select", "single_select"];

export default {
  name: "CreateEntity",
  mixins: [
    alert_mixin,
    formatting_mixins,
    create_questions_crud_mixins,
    dependent_questions_mixin,
  ],
  components: { GlobalTable, CreateSections, CreateQuestions, PreviewForm },

  data: () => ({
    data_points: [],
    removed_question_ids: [],
    question_types: [],
    section_types: [],
    token: get_token(),
    headers: get_headers(),
    project_id: get_project_id(),
    form_id: null,
    active_tab: "Manage Forms",
    sub_active_tab: "Sections",
    tabs: [
      "Manage Forms",
      "Manage Template",
      "Manage Approval Rules",
      "Manage Invoice Steps",
      "Manage Compliance",
    ],
    sub_tabs: ["Sections", "Create Questions", "Preview Form"],
    section_list: [],
    section_table_headers: [],
    table_safe_section_list: [],
    preview_sections: [],
    question_forms: [],
    show_edit_section_modal: false,
    show_edit_modal: false,
    show_dependent_assignment_modal: false,
    show_dependent_details_modal: false,
    current_edit_section: { id: null, name: "", order: null },
    current_edit_question: {},
    section_name_error: false,
    section_name: "",
    option_inputs: ["", ""],
    data_point_tags: {},
    current_main_question: {},
    available_main_questions: [],
    all_main_questions: [],
    all_questions: [],
    assigned_dependent_questions: new Set(),
    current_dependent_question: {},
    open_sections: [],
    open_questions: [],
    open_dependents: [],
    current_edit_mode: null,
    question_open: new Map(),
    dependent_open: new Map(),
    question: {
      is_dependent_mandatory: "",
    },
    backend_options: [
      { value: false, text: "No" },
      { value: true, text: "Yes" },
    ],

    current_reorder_section: null,
    current_reorder_section_index: null,
    current_reorder_questions: [],
    drag_source_index: null,
  }),

  created() {
    this.form_id = this.$route.query.form_id;
    this.question_forms = [this.create_empty_question_form()];
    this.current_edit_question = this.create_empty_edit_question();
  },

  computed: {
    filtered_data() {
      const data_map = {
        "Create Questions": this.question_forms,
        "Preview Form": this.preview_sections,
      };
      return data_map[this.sub_active_tab] || [];
    },
    check_question_type() {
      const type = this.question_types.find(
        (t) => t.id === this.question_type_id
      );
      return SELECT_TYPES.includes(type?.question_type);
    },
  },

  methods: {
    async handle_save_edit() {
      if (this.current_edit_mode === "main_question") {
        await this.save_edited_question();
        await this.get_sections();
      } else if (this.current_edit_mode === "dependent_question") {
        // Add depends_on_id to the data being sent to the backend
        if (this.new_dependent_question) {
          this.new_dependent_question.depends_on_id = this.current_depends_on_id;
        }
        await this.update_dependent_question();
        await this.get_sections();
      } else {
        this.show_error("Unknown edit mode");
      }
    },

    edit_preview_question(question) {
      // Set edit mode
      this.current_edit_mode = 'main_question';
      
      // Convert question structure to match what set_edit_question_data expects
      const question_for_edit = {
        id: question.id,
        question_text: question.text, // Note: your data uses "text" not "question_text"
        question_type: {
          question_type: question.type,
          id: this.get_question_type_id_by_name(question.type) // You need to add this method
        },
        multi_select_choices: question.options || [],
        options: question.options || [],
        data_point: null, // Add if available in your data
        tag: null // Add if available in your data
      };
      
      // Set the edit question data
      this.set_edit_question_data(question_for_edit, 0);
      
      // Show the modal (it will auto-show with data-bs-toggle)
      this.show_edit_modal = true;
    },

    // Add this helper method to get question type ID by name
    get_question_type_id_by_name(questionTypeName) {
      const type = this.question_types.find(t => 
        t.question_type === questionTypeName || 
        t.formatted_type === questionTypeName
      );
      return type ? type.id : '';
    },

    set_edit_question_data(question, question_index) {
      if (!question?.id) {
        this.show_error("Question data incomplete");
        return;
      }
      
      // Safely extract options
      const options = (question.multi_select_choices || question.options || []).map((opt) => {
        if (typeof opt === "object") {
          return {
            choice: opt.choice || "",
            id: opt.id,
          };
        }
        return { choice: opt || "" };
      });

      // Get question type ID
      let question_type_id = '';
      if (question.question_type?.id) {
        question_type_id = question.question_type.id.toString();
      } else if (question.question_type?.question_type) {
        // Try to find the ID from question_types array
        const typeObj = this.question_types.find(t => 
          t.question_type === question.question_type.question_type
        );
        question_type_id = typeObj ? typeObj.id.toString() : '';
      }

      this.current_edit_question = {
        id: question.id.toString(),
        question_index,
        question_text: question.question_text || question.text || "",
        question_type: question.question_type?.question_type || question.type || "",
        question_type_id: question_type_id,
        options: options.length ? options : [{ choice: "" }],
        show_option_inputs: SELECT_TYPES.includes(
          question.question_type?.question_type || question.type || ""
        ),
        data_point_id: question.data_point?.id || null,
        tag_id: question.tag?.id || null,
        selected_tag: question.tag?.id || null,
        available_tags: this.get_tags_for_data_point(question.data_point?.id),
      };
      this.option_inputs = options.map((opt) => opt.choice);
    },

    
    reset_edit_state() {
      this.current_edit_mode = null;
      this.current_depends_on_id = null;
      this.current_dependent_question_id = null;

      this.new_dependent_question = {
        dependent_question_id: null,
        question_text: "",
        question_type_id: "",
        data_point_id: null,
        tag_id: null,
        question_number: "",
        options: [{ choice: "" }, { choice: "" }], // default clean state
        trigger_condition: "",
        is_mandatory: false,
        show_option_inputs: false
      };

      this.current_edit_question = {
        id: null,
        question_index: null,
        question_text: "",
        question_type: "",
        question_type_id: "",
        options: [{ choice: "" }, { choice: "" }],
        show_option_inputs: false,
        data_point_id: null,
        selected_tag: null,
        available_tags: []
      };
    },


    available_questions_for_dependency(parent_question_id) {
      return this.all_questions.filter(
        (question) =>
          question.id !== parent_question_id &&
          !question.is_assigned_as_dependent
      );
    },

    async add_dependent_question(parent_question) {
      if (["multi_select", "single_select"].includes(parent_question.question_type?.question_type)) {
        if (!parent_question.trigger_condition) {
          this.show_warning("Please select a trigger condition");
          return;
        }
      }

      const assignment = {
        main_question_id: parent_question.id,
        dependent_question_id: parseInt(parent_question.new_dependent_id, 10),
        trigger_condition: parent_question.trigger_condition || null,
        is_mandatory: parent_question.is_dependent_mandatory,
        project_id: this.project_id,
        form_id: this.form_id
      };

  try {
    const response = await axios.post(
      ASSIGN_MAIN_QUESTION_AS_DEPENDENT,
      assignment,
      { headers: this.headers }
    );

    const response_data = typeof response.data === "string" ? JSON.parse(response.data) : response.data;

        if (response_data.status === "success") {
          // Reset the form
          parent_question.new_dependent_id = '';
          parent_question.trigger_condition = '';
          parent_question.is_dependent_mandatory = '';

          // Refresh the entire form to get the updated nested structure
          await this.get_form_to_preview();

          // Ensure the parent question shows its dependencies
          parent_question.show_dependencies = true;

          this.show_success("Dependent question added successfully");
        } else {
          this.show_error(`Error: ${response_data.message || "Adding Dependent Question Failed"}`);
        }
      } catch (error) {
        if (error.response?.data) {
          const errorData = typeof error.response.data === "string" ? JSON.parse(error.response.data) : error.response.data;
          this.show_error(`Error: ${errorData.message || error.response.statusText}`);
        } else {
          this.show_error("Error adding dependent question");
        }
      }
    },

    edit_dependency_question(dependent_question) {
        this.reset_edit_state();
        this.current_edit_mode = 'dependent_question';
        this.current_depends_on_id = dependent_question.question_id;
        this.current_dependent_question_id = dependent_question.question_id || dependent_question.id;

        // Determine question type
        const question_type_string = dependent_question.question_type?.question_type || dependent_question.question_type;
        const is_select_type = ['multi_select', 'single_select'].includes(question_type_string);
        // Get question type ID
        const question_type_id = this.get_question_type_id_by_name(question_type_string);

        this.new_dependent_question = {
            dependent_question_id: this.current_dependent_question_id,
            question_text: dependent_question.question_text,
            question_type_id: question_type_id,
            data_point_id: dependent_question.data_point_id || null,
            tag_id: dependent_question.tag_id || null,
            question_number: dependent_question.question_number || '',
            options: (dependent_question.options || []).map(opt => {
                if (typeof opt === 'object') {
                    return { choice: opt.choice || opt };
                }
                return { choice: opt };
            }),
            trigger_condition: dependent_question.trigger_condition || '',
            is_mandatory: dependent_question.is_mandatory || false,
            show_option_inputs: is_select_type, // <-- THIS MUST BE TRUE FOR SELECT TYPES
            depends_on_id: dependent_question.depends_on_id
        };

        // If it's a select type but options array is empty, initialize with 2 empty options
        if (is_select_type && (!this.new_dependent_question.options || this.new_dependent_question.options.length < 2)) {
            this.new_dependent_question.options = [
                { choice: '' },
                { choice: '' }
            ];
        }

        this.show_edit_modal = true;
    },

    // Add this helper method to format options
    format_options_for_display(options) {
      if (!options || options.length === 0) return '';
      
      return options.map(option => 
        typeof option === 'object' ? option.choice : option
      ).join(', ');
    },

    async remove_dependent_question(parent_id, dependent_id) {
      const payload = {
        main_question_id: parent_id,
        dependent_question_id: dependent_id,
      };

      try {
        const response = await axios.post(
          UNASSIGN_DEPENDENT_QUESTION,
          payload,
          { headers: this.headers }
        );

        const response_data = typeof response.data === "string" ? JSON.parse(response.data) : response.data;

        if (response_data.status === "success") {
          // Refresh the entire form to get the updated structure
          await this.get_form_to_preview();
          this.show_success("Dependent question unlinked successfully");
        } else {
          this.show_error(`Error unlinking dependent question: ${response_data.message}`);
        }
      } catch (error) {
        this.show_error(`Error unlinking dependent question: ${error.response?.data?.message || error.message}`);
      }
    },

    create_empty_question_form: () => ({
      question_text: "",
      question_number: "",
      question_type_id: "",
      mandatory: "",
      option_inputs: ["", ""],
      show_option_inputs: false,
    }),

    toggle_section(section_id) {
      const index = this.open_sections.indexOf(section_id);
      if (index > -1) {
        this.open_sections.splice(index, 1);
      } else {
        this.open_sections.push(section_id);
      }
    },

    toggle_question_dependencies(question_id) {
      const toggleInSection = (questions) => {
        for (const question of questions) {
          if (question.id === question_id) {
            question.show_dependencies = !question.show_dependencies;
            return true;
          }
          // Check nested dependent questions
          if (question.dependent_questions && question.dependent_questions.length > 0) {
            if (toggleInSection(question.dependent_questions)) {
              return true;
            }
          }
        }
        return false;
      };

      // Search through all main sections and sub-sections
      for (const main_section of this.preview_sections) {
        if (main_section.sub_sections) {
          for (const sub_section of main_section.sub_sections) {
            if (sub_section.questions && toggleInSection(sub_section.questions)) {
              return;
            }
          }
        }
      }
    },

    toggle_dependent(dependent_id) {
      const index = this.open_dependents.indexOf(dependent_id);
      if (index > -1) {
        this.open_dependents.splice(index, 1);
      } else {
        this.open_dependents.push(dependent_id);
      }
    },

    create_empty_edit_question: () => ({
      id: null,
      question_index: null,
      question_text: "",
      question_type: "",
      question_type_id: "",
      options: [],
      show_option_inputs: false,
      data_point_id: null,
      selected_tag: null,
      available_tags: [],
    }),

    assign_question(section_id) {
      if (!this.form_id) {
        this.show_error("Please save the form first");
        return;
      }
      sessionStorage.setItem("current_form_id", this.form_id);
      sessionStorage.setItem("current_section_id", section_id);
      this.$router.push({
        path: "/manage_questions",
        query: {
          form_id: this.form_id,
          section_id,
          project_id: this.project_id,
        },
      });
    },

    handle_question_type_change(question) {
        // Get the question type ID
        const question_type_id = this.current_edit_mode === 'dependent_question' 
            ? this.new_dependent_question.question_type_id 
            : question.question_type_id;
        const type = this.question_types.find(t => t.id == question_type_id);

        const show_option_inputs = SELECT_TYPES.includes(type?.question_type);

        if (this.current_edit_mode === "dependent_question") {
            // For dependent questions
            this.new_dependent_question.show_option_inputs = show_option_inputs;
            
            if (show_option_inputs) {
                // Ensure we have at least 2 options
                if (
                    !this.new_dependent_question.options ||
                    this.new_dependent_question.options.length < 2
                ) {
                    this.new_dependent_question.options = [{ choice: "" }, { choice: "" }];
                }
            } else {
                this.new_dependent_question.options = [];
            }
        } else {
            // For main questions
            question.show_option_inputs = show_option_inputs;
            if (show_option_inputs) {
                // Initialize options if not present
                if (!question.options || question.options.length < 2) {
                    question.options = [{ choice: "" }, { choice: "" }];
                }
            } else {
                question.options = [];
            }
        }
        
        // Force Vue to update the view
        this.$forceUpdate();
    },

    add_option_input(question) {
      if (!question.options) {
        question.options = [];
      }
      question.options.push({ choice: "" });
    },

    remove_option_input(form, index) {
      if (form.options && form.options.length > 2) {
        form.options.splice(index, 1);
      }
    },

    update_option(index, value, form) {
      if (
        Number.isInteger(index) &&
        index >= 0 &&
        index < form.option_inputs.length
      ) {
        const sanitized_value =
          typeof value === "string" &&
            value.trim() !== "" &&
            /^[a-zA-Z0-9 ]+$/.test(value)
            ? String(value.trim())
            : Reflect.get(form.option_inputs, index);

        // Use Reflect to set value safely
        Reflect.set(form.option_inputs, index, sanitized_value);
      }
    },


   

    async unassign_question(question_id) {
      const payload = {
        question_id: question_id,
        project_id: this.project_id,
        form_id: this.form_id,
      };

      await axios.post(
        UNASSIGN_QUESTIONS_TO_FORM_SECTION,
        payload,
        { headers: this.headers }
      ).then(() => {
        this.show_success("Question unassigned successfully");
        this.get_form_to_preview();
      }).catch((error) => {
        const message = error.response?.data?.message || error.message;
        this.show_error(message);
      });
    },

    fetch_sections() {
      axios
        .get(SECTIONS_LIST_URLS, { headers: this.headers })
        .then(({ data }) => {
          this.section_types = data.data || [];
        })
        .catch((error) => {
          this.show_error(
            `Error fetching sections: ${error.response?.data?.message || error.message
            }`
          );
        });
    },

    open_edit_section_modal(section) {
      this.current_edit_section = {
        id: section.id,
        name: section.section_name,
        order: section.order,
      };
      this.show_edit_section_modal = true;
      this.section_name_error = false;
    },

    async get_data_point_types() {
      const { data } = await axios.get(QUESTION_TYPE_URLS, { headers: this.headers });
      const types = typeof data === 'string' ? JSON.parse(data) : data;
      this.question_types = types.data.map(item => ({
        ...item,
        formatted_type: this.format_question_type(item.question_type),
      }));
    },


    async get_sections() {
      this.section_list = [];
      const { data } = await axios.post(
        GET_SECTIONS_IN_FORM,
        { form_id: this.form_id },
        { headers: this.headers }
      );

      if (data?.data?.length) {
        this.section_list = data.data;
        this.prep_tables();
      }
    },

    prep_tables() {
      if (this.section_list.length) {
        this.table_safe_section_list = this.section_list.map((section) => ({
          id: section.section_id,
          section_name: section.section_name,
        }));
        this.section_table_headers = Object.keys(
          this.table_safe_section_list[0]
        );
      }
      this.initialize_data_table();
    },

    async get_form_to_preview() {
  try {
    await this.get_data_points();
    await this.fetch_all_data_point_tags();

    const { data } = await axios.get(GET_FORM_WITH_MAIN_SECTIONS, {
      headers: this.headers,
      params: { form_id: this.form_id },
    });

    const response = typeof data === "string" ? JSON.parse(data) : data;
    const form_data = response.data || [];

    // Transform into frontend-friendly structure
    this.preview_sections = form_data
      .sort((a, b) => (a.order_number || 999) - (b.order_number || 999))
      .map(main => ({
        id: main.id,
        name: main.main_section_name,
        order: main.order_number,
        sub_sections: (main.sub_sections || [])
          .sort((a, b) => (a.order_number || 999) - (b.order_number || 999))
          .map(sub => ({
            id: sub.section_id,
            name: sub.section_name,
            order: sub.order_number,
            questions: (sub.questions || [])
              .filter(q => !this.removed_question_ids.includes(q.question_id)) // keep your removal rule
              .sort((a, b) => (a.order_number || 999) - (b.order_number || 999))
              .map(q => ({
                section_question_id: q.section_question_id,  // <-- keep this!
                id: q.question_id,
                text: q.question_text,
                type: q.question_type,
                mandatory: q.is_mandatory,
                options: q.options || [],
                dependent_questions: q.dependent_questions || []
              }))
          }))
      }));

    await this.fetch_all_questions();
    this.initialize_question_states();

  } catch (error) {
  
    this.show_error("Failed to load form preview");
  }
    },

    async fetch_all_questions() {
      const payload = { 
        project_id: this.project_id,
        only_assigned: true,
        form_id: this.form_id,
      };
      const response = await axios.post(GET_QUESTIONS_IN_PROJECT, payload, {
        headers: this.headers,
      });

      const response_data = typeof response.data === "string" ? JSON.parse(response.data) : response.data;
      this.all_questions = response_data.data || [];
      this.available_main_questions = this.all_questions.filter(
        q => !q.is_assigned_as_dependent
      );
    },

    map_question(question) {
      const data_point = question.key_data_points?.[0] || null;
      const data_point_id = data_point?.id || null;

      const tag = question.tag || null;
      const available_tags = this.get_tags_for_data_point(data_point_id);
      const selected_tag = available_tags.find((t) => t.id === tag?.id)?.id || null;
      const dependent_questions = (question.dependent_questions || []).map(dep => {
        const mapped_dep = this.map_dependent_question(dep);
        return {
          ...mapped_dep,
          new_dependent_id: mapped_dep.new_dependent_id || "",
          trigger_condition: mapped_dep.trigger_condition || "",
          is_dependent_mandatory: mapped_dep.is_dependent_mandatory || false,
          show_dependencies: mapped_dep.show_dependencies || false,
          can_have_dependents: mapped_dep.can_have_dependents || false
        };
      });

      return {
        section_question_id: question.section_question_id,
        id: question.id,
        question_text: question.question_text,
        question_type: {
          question_type: question.question_type.question_type,
          id: question.question_type.id,
        },
        is_mandatory: question.is_mandatory,
        is_assigned: question.is_assigned, // Make sure this is included
        question_number: question.question_number,
        options: question.options || [],
        multi_select_choices: question.multi_select_choices || [],
        data_point: data_point,
        data_point_id: data_point_id,
        tag: tag
          ? {
            id: tag.id,
            tag_name: tag.tag_name,
            data_point_id: tag.data_point_id,
          }
          : null,
        tag_id: tag?.id || null,
        tag_name: tag?.tag_name || null,
        available_tags: available_tags,
        selected_tag: selected_tag,
        dependent_questions: dependent_questions,
        new_dependent_id: "",
        trigger_condition: "",
        is_dependent_mandatory: "",
        show_dependencies: false,
        show_dependency_assignment: false
      };
    },

    map_dependent_question(dep_question) {
      if (!dep_question) {
        return this.create_empty_dependent_question();
      }

      const is_full_question = 'multi_select_choices' in dep_question || 'key_data_points' in dep_question;
      let question_data;

      if (is_full_question) {
        question_data = dep_question;
      } else {
        const full_question = this.find_question_by_id_in_all_sections(dep_question.question_id);
        question_data = full_question || dep_question;
      }

      const dep_data_point = question_data.key_data_points?.[0] || null;
      const dep_data_point_id = dep_data_point?.id || null;

      const dep_tag = question_data.tag || null;
      const dep_available_tags = this.get_tags_for_data_point(dep_data_point_id);
      const dep_selected_tag = dep_available_tags.find(t => t.id === dep_tag?.id)?.id || null;

      let question_type_obj;
      if (question_data.question_type && typeof question_data.question_type === 'object') {
        question_type_obj = question_data.question_type;
      } else {
        question_type_obj = {
          question_type: question_data.question_type || dep_question.question_type,
          id: null
        };
      }

      const question_type_string = question_type_obj.question_type;
      const can_have_dependents = ['multi_select', 'single_select'].includes(question_type_string);

      const nested_dependent_questions = (question_data.dependent_questions || [])
        .map(nested_dep => this.map_dependent_question(nested_dep))
        .filter(Boolean);

      return {
        id: question_data.id || dep_question.question_id,
        question_text: question_data.question_text || dep_question.question_text,
        question_type: question_type_obj,
        is_mandatory: question_data.is_mandatory !== undefined ? question_data.is_mandatory : dep_question.is_mandatory,
        question_number: question_data.question_number || null,
        options: question_data.options || [],
        multi_select_choices: question_data.multi_select_choices || [],
        data_point: dep_data_point,
        data_point_id: dep_data_point_id,
        tag: dep_tag ? {
          id: dep_tag.id,
          tag_name: dep_tag.tag_name,
          data_point_id: dep_tag.data_point_id
        } : null,
        tag_id: dep_tag?.id || null,
        tag_name: dep_tag?.tag_name || null,
        available_tags: dep_available_tags,
        selected_tag: dep_selected_tag,
        depends_on_id: dep_question.depends_on_id,
        trigger_condition: dep_question.trigger_condition,
        dependent_questions: nested_dependent_questions,
        new_dependent_id: "",
        is_dependent_mandatory: dep_question.is_mandatory || false,
        show_dependencies: false,
        can_have_dependents: can_have_dependents,
        show_dependency_assignment: false,
      };
    },

    create_empty_dependent_question() {
      return {
        id: null,
        question_text: '',
        question_type: { question_type: '', id: null },
        is_mandatory: false,
        question_number: null,
        options: [],
        multi_select_choices: [],
        data_point: null,
        data_point_id: null,
        tag: null,
        tag_id: null,
        tag_name: null,
        available_tags: [],
        selected_tag: null,
        depends_on_id: null,
        trigger_condition: '',
        dependent_questions: [],
        new_dependent_id: "",
        is_dependent_mandatory: false,
        show_dependencies: false,
        can_have_dependents: false
      };
    },

    // Add this method to find the full question data by ID across all sections
    find_question_by_id_in_all_sections(question_id) {
      for (const section of this.preview_sections) {
        for (const question of section.questions) {
          if (question.id === question_id) {
            return question;
          }
        }
      }
      
      return null;
    },

    // Add to methods section
    get_parent_question_text(parent_id) {
      // Search through all main sections and sub-sections to find the parent question
      for (const main_section of this.preview_sections) {
        if (main_section.sub_sections) {
          for (const sub_section of main_section.sub_sections) {
            if (sub_section.questions) {
              for (const question of sub_section.questions) {
                if (question.id === parent_id) {
                  return question.text?.substring(0, 20) + (question.text?.length > 20 ? '...' : '');
                }
                // Also check nested dependent questions
                if (question.dependent_questions) {
                  for (const dep_question of question.dependent_questions) {
                    if (dep_question.question_id === parent_id) { // Note: dependent questions use question_id
                      return dep_question.question_text?.substring(0, 20) + (dep_question.question_text?.length > 20 ? '...' : '');
                    }
                  }
                }
              }
            }
          }
        }
      }
      return 'Parent question';
    },

    // Enhanced method to find questions recursively
    find_question_by_id(questions, target_id) {
      for (const question of questions) {
        if (question.id === target_id) {
          return question;
        }
        if (question.dependent_questions && question.dependent_questions.length > 0) {
          const found = this.find_question_by_id(question.dependent_questions, target_id);
          if (found) return found;
        }
      }
      return null;
    },

    // Enhanced method to update questions recursively
    update_question_dependencies(questions, question_id, dependent_questions) {
      for (const question of questions) {
        if (question.id === question_id) {
          question.dependent_questions = dependent_questions;
          return true;
        }
        if (question.dependent_questions && question.dependent_questions.length > 0) {
          const updated = this.update_question_dependencies(question.dependent_questions, question_id, dependent_questions);
          if (updated) return true;
        }
      }
      return false;
    },

    async set_active_tab(tab) {
      this.active_tab = tab;
      await nextTick();
      this.initialize_data_table();
    },

    async set_sub_active_tab(tab) {
      this.sub_active_tab = tab;
      await nextTick();
      this.initialize_data_table();
    },

    initialize_data_table() {
      this.$nextTick(() => {
        const table_map = {
          Sections: "#create-sections-table",
        };

        const table_id = table_map[this.sub_active_tab];
        if (!table_id || !document.querySelector(table_id)) return;

        if ($.fn.DataTable.isDataTable(table_id)) {
          $(table_id).DataTable().destroy();
        }

        $(table_id).DataTable({ responsive: true, destroy: true });
      });
    },

    add_question_form() {
      this.question_forms.push(this.create_empty_question_form());
    },

    remove_question_form(index) {
      this.question_forms.splice(index, 1);
    },

    reset_question_form() {
      this.question_forms = [this.create_empty_question_form()];
      this.option_inputs = ["", ""];
    },

    async fetch_all_data_point_tags() {
      const response = await axios.get(GET_ASSIGNED_DATA_POINTS, {
        headers: this.headers,
        params: { project_id: this.project_id },
      });

      if (response.data.status === "success") {
        const tags_map = {};
        response.data.data.forEach((tag) => {
          if (!tags_map[tag.data_point_id]) {
            tags_map[tag.data_point_id] = [];
          }
          tags_map[tag.data_point_id].push({
            id: Number(tag.tag_id),
            tag_name: tag.tag_name,
            data_point_id: tag.data_point_id,
          });
        });
        this.data_point_tags = tags_map;
      }
    },

    get_tags_for_data_point(data_point_id) {
      if (!Array.isArray(this.data_points)) {
        return [];
      }

      const numeric_id = Number(data_point_id);
      if (!Number.isSafeInteger(numeric_id) || numeric_id < 1) return [];

      const valid_keys = new Set(this.data_points.map((dp) => dp.id));
      if (!valid_keys.has(numeric_id)) return [];

      if (!(this.data_point_tags instanceof Object)) return [];

      const tags = Reflect.get(this.data_point_tags ?? {}, numeric_id) || [];
      return Array.isArray(tags) ? tags : [];
    },

    async get_data_points() {
      const response = await axios.get(LIST_DATA_POINTS_URL, {
        params: { project_id: this.project_id },
        headers: this.headers,
      });
      const response_data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
      if (response_data.data && Array.isArray(response_data.data.data)) {
        this.data_points = response_data.data.data;
      } else if (Array.isArray(response_data.data)) {
        this.data_points = response_data.data;
      } else {
        this.data_points = [];
      }
    },

    open_reorder_modal(section, section_index) {
      // Pass the entire main_section and sub_section for proper context
      this.current_reorder_section = section;
      this.current_reorder_section_index = section_index;
      this.current_reorder_questions = JSON.parse(
        JSON.stringify(section.questions || []) // Add fallback for empty array
      );
    },

    drag_start(event, index) {
      this.drag_source_index = index;
      event.target.style.opacity = "0.6";
      event.dataTransfer.effectAllowed = "move";
    },

    drag_over(event) {
      event.preventDefault();
      event.dataTransfer.dropEffect = "move";
    },

    drag_drop(event, target_index) {
      event.preventDefault();

      if (
        this.drag_source_index === null ||
        this.drag_source_index === target_index
      ) {
        return;
      }
      const questions = [...this.current_reorder_questions];
      const dragged_question = questions.splice(this.drag_source_index, 1)[0];
      questions.splice(target_index, 0, dragged_question);

      this.current_reorder_questions = questions;
      this.drag_source_index = null;
    },

    drag_end(event) {
      event.target.style.opacity = "1";
      this.drag_source_index = null;
    },

    async save_question_order() {
      try {
        // Make sure we have valid questions to reorder
        if (!this.current_reorder_questions || !Array.isArray(this.current_reorder_questions)) {
          this.show_error("No questions to reorder");
          return;
        }

        const payload = this.current_reorder_questions
          .filter(q => q && (q.section_question_id || q.id)) // Filter out invalid questions
          .map((q, index) => ({
            section_question_id: q.section_question_id || q.id,
            order_number: index + 1,
          }));

        if (payload.length === 0) {
          this.show_error("No valid questions to reorder");
          return;
        }

        await axios.post(REORDER_SECTION_QUESTIONS, payload, {
          headers: this.headers,
        });

        // Update the correct questions in the new structure
        // You might need to pass more context about which sub-section to update
        // For now, assuming current_reorder_section is the sub-section
        if (this.current_reorder_section) {
          this.current_reorder_section.questions = JSON.parse(JSON.stringify(this.current_reorder_questions));
        }

        this.show_success("Questions ordering updated successfully");
        this.close_modal("reorder_questions_modal");
      } catch (error) {
        this.show_error(
          error.response?.data?.message ||
          error.message ||
          "Failed to reorder questions"
        );
      }
    },


    async assign_dependent_question(question) {
      this.current_main_question = { ...question };
      await this.fetch_all_main_questions();
      this.available_main_questions = this.all_main_questions
        .filter(
          (q) =>
            q.id !== question.id && !this.assigned_dependent_questions.has(q.id)
        )
        .map((q) => ({
          ...q,
          selected: false,
          trigger_condition: "",
          is_mandatory: false,
        }));

      this.show_dependent_assignment_modal = true;
    },

    async fetch_all_main_questions() {
      const payload = {
        project_id: this.project_id,
        only_assigned: true,
        form_id: this.form_id,
      };
      const response = await axios.post(GET_QUESTIONS_IN_PROJECT, payload, {
        headers: this.headers,
      });
      const response_data =
        typeof response.data === "string"
          ? JSON.parse(response.data)
          : response.data;
      const all_questions = response_data.data;
      this.all_main_questions = all_questions.filter(
        (q) => !q.is_assigned_as_dependent
      );
      this.assigned_dependent_questions = all_questions.filter(
        (q) => q.is_assigned_as_dependent
      );
      const dependent_ids = new Set();
      all_questions
        .filter((q) => q.is_assigned_as_dependent)
        .forEach((q) => dependent_ids.add(q.id));
      this.assigned_dependent_questions_set = dependent_ids;
    },

    handle_question_toggle(question) {
      if (!question.selected) {
        question.trigger_condition = "";
        question.is_mandatory = false;
      }
    },

    async save_dependent_assignment() {
      const selected_questions = this.available_main_questions.filter(
        (q) => q.selected
      );

      if (selected_questions.length === 0) {
        this.show_warning(
          "Please select at least one question to assign as dependent"
        );
        return;
      }

      if (
        ["multi_select", "single_select"].includes(
          this.current_main_question.question_type.question_type
        )
      ) {
        const invalid_questions = selected_questions.filter(
          (q) => !q.trigger_condition
        );
        if (invalid_questions.length > 0) {
          this.show_warning(
            "Please select a trigger condition for all selected questions"
          );
          return;
        }
      }

      const assignments = selected_questions.map((question) => ({
        main_question_id: this.current_main_question.id,
        dependent_question_id: question.id,
        trigger_condition: question.trigger_condition,
        is_mandatory: question.is_mandatory,
      }));

      const promises = assignments.map((assignment) =>
        axios.post(ASSIGN_MAIN_QUESTION_AS_DEPENDENT, assignment, {
          headers: this.headers,
        })
      );

      const responses = await Promise.all(promises);

      responses.forEach((response) => {
        const response_data =
          typeof response.data === "string"
            ? JSON.parse(response.data)
            : response.data;
        if (response_data.status === "success") {
          this.assigned_dependent_questions.push(
            response_data.data.dependent_question_id
          );
        }
      });

      this.show_success("Dependent questions assigned successfully");
      this.show_dependent_assignment_modal = false;

      await this.get_form_to_preview();
    },

    view_dependent_question_details(dependent_question) {
      this.current_dependent_question = { ...dependent_question };
      this.show_dependent_details_modal = true;
    },

    initialize_question_states() {
      // Add a null/undefined check for preview_sections
      if (!Array.isArray(this.preview_sections)) {
        return;
      }

      this.preview_sections.forEach((main_section) => {
        // Check if main_section exists and has sub_sections
        if (main_section && Array.isArray(main_section.sub_sections)) {
          main_section.sub_sections.forEach((sub_section) => {
            // Check if sub_section exists and has questions
            if (sub_section && Array.isArray(sub_section.questions)) {
              sub_section.questions.forEach((question) => {
                // Initialize question properties safely
                if (question) {
                  if (question.new_dependent_id === undefined) {
                    question.new_dependent_id = "";
                  }
                  if (question.trigger_condition === undefined) {
                    question.trigger_condition = "";
                  }
                  if (question.is_dependent_mandatory === undefined) {
                    question.is_dependent_mandatory = false;
                  }
                  if (question.show_dependencies === undefined) {
                    question.show_dependencies = false;
                  }
                  if (question.show_dependency_assignment === undefined) {
                    question.show_dependency_assignment = false;
                  }
                }
              });
            }
          });
        }
      });
    },

    toggle_dependency_assignment(question_id) {
      const toggle_in_Section = (questions) => {
        for (const question of questions) {
          if (question.id === question_id) {
            question.show_dependency_assignment = !question.show_dependency_assignment;
            return true;
          }
          if (question.dependent_questions && question.dependent_questions.length > 0) {
            if (toggle_in_Section(question.dependent_questions)) {
              return true;
            }
          }
        }
        return false;
      };

      // Search through all main sections and sub-sections
      for (const main_section of this.preview_sections) {
        if (main_section.sub_sections) {
          for (const sub_section of main_section.sub_sections) {
            if (sub_section.questions && toggle_in_Section(sub_section.questions)) {
              return;
            }
          }
        }
      }
    },
  },

  async mounted() {
  this.data_points = this.data_points || [];
  this.headers = get_headers();
  
  try {
    await this.get_sections();
    await this.get_data_point_types();
    await this.get_form_to_preview(); // This populates preview_sections
    await this.fetch_all_main_questions();
    await this.get_data_points();
    await this.fetch_all_data_point_tags();
    this.initialize_data_table();
    
    // Only initialize question states if preview_sections is populated
    if (this.preview_sections && Array.isArray(this.preview_sections)) {
      this.initialize_question_states();
    }
  } catch (error) {

    this.show_error("Failed to initialize form preview");
  }
},

  watch: {
    question_type_id() {
      this.handle_question_type_change(this);
    },
    create_sections: "initialize_data_table",
    create_questions: "initialize_data_table",
    preview_form: "initialize_data_table",
  },
};